import React from 'react';

export default function Toggle({ label, checked, onChange, leftLabel, rightLabel, disabled = false }) {
    return (
        <div className="flex flex-col">
            {label && <label className="block text-sm font-medium mb-1 text-gray-900 dark:text-white">{label}</label>}
            <div className="flex items-center gap-3">
                {leftLabel && (
                    <span className={`text-sm ${!checked ? 'font-bold text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`}>
                        {leftLabel}
                    </span>
                )}

                <button
                    type="button"
                    role="switch"
                    aria-checked={checked}
                    onClick={() => !disabled && onChange(!checked)}
                    disabled={disabled}
                    className={`
            relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent 
            transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
            ${checked ? 'bg-blue-600' : 'bg-gray-200 dark:bg-slate-700'}
            ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
                >
                    <span
                        aria-hidden="true"
                        className={`
              pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 
              transition duration-200 ease-in-out
              ${checked ? 'translate-x-5' : 'translate-x-0'}
            `}
                    />
                </button>

                {rightLabel && (
                    <span className={`text-sm ${checked ? 'font-bold text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`}>
                        {rightLabel}
                    </span>
                )}
            </div>
        </div>
    );
}
